var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-15 40.914 4.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.42 7.488v-5.03C29.42.87 28.254-.297 27.05.067l-15.1 4.619H6.85A6.789 6.789 0 0 0 .262 9.468a6.694 6.694 0 0 0 5.25 8.444v6.379a1.434 1.434 0 0 0 1.435 1.434H8.86a1.435 1.435 0 0 0 1.434-1.434v-6.216h.957l15.703 4.619c1.262.373 2.468-.804 2.468-2.391v-5.9a2.495 2.495 0 0 0 1.912-2.363V9.85a2.497 2.497 0 0 0-1.913-2.362z",
    mask: "url(#bjcwmzhhqb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.28 18.116a.956.956 0 0 1-1.191-1.087 9.563 9.563 0 0 0-3.037-8.71.958.958 0 0 1 1.282-1.423 11.475 11.475 0 0 1 3.641 10.45.956.956 0 0 1-.694.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.252 20.964a.956.956 0 0 1-1.124-1.313 11.953 11.953 0 0 0-4.893-15.194.956.956 0 0 1 .956-1.642 13.867 13.867 0 0 1 5.708 17.61c-.12.27-.36.469-.647.539z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.68aecddd2c521e946857b9f76243abfb.svg";
export { ForwardRef as ReactComponent };